import { Layers } from "appworks/graphics/layers/layers";
import { AbstractControl } from "appworks/ui/controls/abstract-control";
import { ControlFactory } from "appworks/ui/factories/control-factory";
import { EpicAutoplayMenuControl } from "epic/controls/epic-autoplay-menu-control";

export class EpicAutoplayMenuControlFactory implements ControlFactory {
    public filter(layer: Layers): boolean {
        if (layer.getShape("cover") && layer.getSprite("autoplay_background")) {
            return true;
        }
        return false;
    }

    public build(layer: Layers): AbstractControl[] {
        return [ new EpicAutoplayMenuControl(layer.getShape("cover"), layer.getSprite("autoplay_background")) ];
    }
}
